import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../../../types/integrations/IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';
import { PackagedTypeEnum } from '../../../types/properties/PackagedTypeEnum';
import { AccessControlServiceDropdownOptions } from './accessControl';
import { IdentityProviderDropdownOptions } from './identityProvider';

/**
 * @deprecated Use `AccessManagementDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { AccessManagementDefinition } from 'application-types';`
 */
const AccessManagementDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.AccessManagement,
  hasCustomUI: true,
  allowsMultipleInstances: false,
  friendlyName: 'Access Management',
  description:
    'Defines the properties required for an access control integration.',
  category: IntegrationCategoryEnum.AccessControl,
  platforms: [PlatformEnum.Web, PlatformEnum.Mobile],
  type: IntegrationTypeEnum.Api,
  // Nested provider settings (identityProviderSettings / accessControlSettings)
  // hold server-side credentials. Deny unmarked fields by default so newly
  // added credential fields never leak to unprivileged clients; only fields
  // explicitly marked `clientSafe` or `secure` are evaluated for exposure.
  defaultPolicy: 'deny',
  settings: {},
  properties: {
    identityProviderService: {
      friendlyName: 'Identity Provider Service',
      packagedType: PackagedTypeEnum.Dropdown,
      type: 'Option',
      validators: [
        {
          name: 'Required',
          value: true,
        },
        {
          name: 'In',
          value: IdentityProviderDropdownOptions,
        },
      ],
    },
    identityProviderSettings: {
      forDisplay: false,
      friendlyName: 'Identity Provider Service Settings',
      description: 'Storage for provider-specific property values.',
      type: String.name,
      validators: [],
      nestedPropertyRules: {
        checkSecurity: true,
        dynamicProviderKey: 'identityProviderService.value',
      },
    },
    accessControlService: {
      friendlyName: 'Access Control Service',
      packagedType: PackagedTypeEnum.Dropdown,
      type: 'Option',
      validators: [
        {
          name: 'Required',
          value: true,
        },
        {
          name: 'In',
          value: AccessControlServiceDropdownOptions,
        },
      ],
    },
    accessControlSettings: {
      forDisplay: false,
      friendlyName: 'Access Control Service Settings',
      description: 'Storage for provider-specific property values.',
      type: String.name,
      validators: [],
      nestedPropertyRules: {
        checkSecurity: true,
        dynamicProviderKey: 'accessControlService.value',
      },
    },
  },
};

/**
 * @deprecated Use `AccessManagementDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { AccessManagementDefinition } from 'application-types';`
 */
export default AccessManagementDefinition;
